import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import OvarianDetailsFemale from "./OvarianDetailsFemale.jsx";
import { useAuth } from "../../../../provider.jsx";
import { useTranslation } from '../../../../language';
import { Stack, Typography } from "@mui/material";
import { Venus } from 'lucide-react';

export default function BloodFertilityWelcome() {

  const { state } = useAuth();
  const gender = state?.user?.gender;
  const isMale = gender === "M";
  const { t } = useTranslation();

  return (

    <PageProtectedLayout
      headline={t('page_hl_female')}
      specify={t('page_sp_fertility')}
      headlineNoWrap
    >

      {isMale ? (

        <Stack direction="row" spacing={4} sx={{ mt: 2 }}>
          <Venus size={30} />
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
            This section content is available for female users only.
          </Typography>
        </Stack>

      ) : (

        <OvarianDetailsFemale />

      )}

    </PageProtectedLayout>

  );
}
